import React from "react";

export const Leitor = (props) => {
  return (
    <div id="leitor">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/maquina3.png" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="leitor-text">
              <h2>Dispositivos Inteligentes "LEITOR"</h2>
              <p>{props.data ? props.data.paragraph : "Carregando..."}</p>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}> <i class="fa fa-check" aria-hidden="true"></i>
 {d}</li>
                        ))
                      : "Carregando..."}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
